import styled from "styled-components/native";
import { light_black } from "../../StyleHelpers";

export const StyledContainer = styled.View`
	background-color: ${light_black};
	height: 100%;
`;

export const StyledMain = styled.View`
	margin: 8.8% 0 2% 0;
`;

export const StyledTextInputSpace = styled.View`
	margin-bottom: 5%;
`;

/*Narrow*/
export const StyledButtonsContainer = styled.View`
	display: flex;
	width: 31.25rem;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
`;

export const StyledButtonsWrapper = styled.View`
	display: flex;
	flex-direction: column;
	// align-items: flex-start;
	gap: 1rem;
	align-self: stretch;
`;

export const StyledNarrowTextInput = styled.View`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	flex: 1 0 0;
`;

export const StyledNarrowTextContainer = styled.View`
	margin-top: -6px;
`;
